import { Alert, AlertDescription, AlertTitle, Button } from '@1trading/react';
import { getErrorMessage } from '@/lib/api/error';

interface QueryErrorBannerProps {
  /** Legacy toast copy, e.g. "Failed to fetch fee bands" */
  title?: string;
  error?: unknown;
  /** Explicit copy — overrides the message derived from `error` */
  message?: string;
  onRetry?: () => void;
}

/**
 * Shared "query failed → message + Retry" banner, built on the
 * library's destructive Alert — it supplies role="alert" internally, so screen
 * readers announce the failure without any manual wiring.
 */
export const QueryErrorBanner = ({ title, error, message, onRetry }: QueryErrorBannerProps) => (
  <Alert variant="destructive">
    {title ? <AlertTitle>{title}</AlertTitle> : null}
    <AlertDescription className="flex flex-wrap items-center gap-3">
      <span>{message ?? getErrorMessage(error)}</span>
      {onRetry ? (
        <Button onClick={onRetry} size="sm" type="button" variant="outline">
          Retry
        </Button>
      ) : null}
    </AlertDescription>
  </Alert>
);
QueryErrorBanner.displayName = 'QueryErrorBanner';
